import axios from '../../../axios'


// 主页
export const init = (data) => {
  return axios({
    url: '/home/init',
    method: 'post',
    data
  })
}
export const topMenu = (data) => {
  let params={
    method:'post',
    url: '/home/topMenu',
    data
  }
  return axios(params);
}

// 获取页面层级路径
export const getPageLevel = (data) => {
  let params={
    method:'post',
    url: '/home/getPageLevel',
    data
  }
  return axios(params);
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/home/home.js